import { getApiUrl, getCookieDomain } from "./api/util";

const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
};

const setCookie = (
  name: string,
  value: string,
  domain?: string,
  days?: number,
) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }
  const domainPart = domain ? `; domain=${domain}` : "";
  document.cookie = `${name}=${value || ""}${expires}; path=/${domainPart}`;
};

export default async function getClientSideCSRF(): Promise<string | null> {
  const currentCSRF = getCookie("csrftoken");
  if (currentCSRF) return currentCSRF;

  // Make a request to the Django endpoint
  const response = await fetch(getApiUrl("ping/"));
  // Check if response is okay
  if (!response.ok) throw new Error("Failed to get CSRF token from server");
  // Extract the CSRF token from the response body
  const data = await response.json();
  const { csrfToken } = data;
  if (!csrfToken) {
    throw new Error("Failed to get CSRF token");
  }

  const configuredDomain = getCookieDomain();
  const shouldUseHostOnlyCookie =
    !configuredDomain ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";

  // Keep localhost dev on a host-only cookie so the browser will actually send it back.
  setCookie(
    "csrftoken",
    csrfToken,
    shouldUseHostOnlyCookie ? undefined : configuredDomain,
    1,
  );

  return csrfToken;
}
